import React, { FC } from 'react';

import { formatAccountNumber } from '@eika-infrastruktur/format';
import { copyToClipboard } from '@eika-infrastruktur/utils';
import { IconButton } from '@eika/button';
import { IconTypes } from '@eika/icon';

import type { Account } from '../../generated-types';
import useTranslation from '../../hooks/useTranslation';
import { AccountLabels } from '../shared/AccountLabels';

import '../AccountView/AccountView.scss';

export interface Props {
    account?: Account;
}

const AccountViewActions: FC<Props> = ({ account }) => {
    const translated = useTranslation();
    if (!account) {
        return <></>;
    }
    return (
        <div className="account-header__wrapper">
            <dl className="sgw-account-details__meta" itemScope itemType="https://schema.org/DepositAccount">
                <dt className="screen-reader-text">{translated.accountOwners}</dt>
                <dd className="account-header__owners">
                    <AccountLabels owners={account.owners} />
                </dd>

                <dt className="screen-reader-text">{translated.accountName}</dt>
                <dd itemProp="name" className="account-details__name">
                    <h1 className="light" data-testid="account-name-header">
                        {account.alias}
                    </h1>
                </dd>

                <dt className="screen-reader-text typography-paragraph">{translated.accountNumber}</dt>
                <dd
                    className="account-details__accountId"
                    itemProp="accountId"
                    itemScope
                    itemType="https://schema.org/accountId"
                    data-testid="account-number"
                >
                    {formatAccountNumber(account.accountNumber)}
                    <IconButton
                        icon={IconTypes.COPY_24}
                        screenReaderText={translated.accountDetails.copyAccountNumber}
                        onClick={() => copyToClipboard(account?.accountNumber.value)}
                    />
                </dd>
            </dl>
        </div>
    );
};

export default AccountViewActions;
